__turbopack_context__.v({
  "card": "CrmCustomDevelopment-module__wAONJG__card",
  "eyebrow": "CrmCustomDevelopment-module__wAONJG__eyebrow",
  "grid": "CrmCustomDevelopment-module__wAONJG__grid",
  "head": "CrmCustomDevelopment-module__wAONJG__head",
  "iconWrap": "CrmCustomDevelopment-module__wAONJG__iconWrap",
  "list": "CrmCustomDevelopment-module__wAONJG__list",
  "section": "CrmCustomDevelopment-module__wAONJG__section",
  "title": "CrmCustomDevelopment-module__wAONJG__title",
});
